export default "<button title=\"{{'BUTTONS.SAVE' | translate}}\" class=\"btn btn-primary\" (click)=\"saveBlue()\">{{'BUTTONS.SAVE' | translate}}</button>\r\n";